import { describeFields, FieldWidget } from '../common/fields';
import { VideoSchema } from './schemas';

export const VIDEO_FIELDS = describeFields(VideoSchema, {
  subject: {},
  videoId: {},
  topic: {},
  youtubeId: {},
  playbackProvider: {},
  gumletAssetId: {},
  topicResources: { widget: FieldWidget.Text },
  title: {},
  description: { widget: FieldWidget.LongText },
  creationDatetime: { widget: FieldWidget.Text },
  resources: { widget: FieldWidget.Text },
  topicVideos: { widget: FieldWidget.Text },
  relatedVideos: { widget: FieldWidget.Text },
  pathLabels: {},
  host: {},
});
